module.exports = __webpack_public_path__ + "static/media/04.91e11b35.png";